module.exports = __webpack_public_path__ + "static/media/homepage-overlay-2.b0d01fc1.jpg";